import Vue from "vue";
import VeeValidate from "vee-validate";
import emailValidator from "./uniqueEMail";

Vue.use(VeeValidate);

emailValidator.init();
